export abstract class DialogBase {

    abstract apply(): void;

    abstract cancel(): void;

    abstract close(): void;
}